import React, { useState } from "react";
import Header from "../components/Common/Header/Header";
import Axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const Register = () => {
  const navigate = useNavigate();
  const [verifyCaptcha, setVerifyCaptcha] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    try {
      const response = await Axios.post("https://bpdacadmin.icicle.dev/api/userRegister", formData);
      console.log(response);
      if (response.status === 200 && response.data.status === "ok") {
        Swal.fire({
          icon: "success",
          title: "register successfully!",
          text: "Please check and verify your email",
          confirmButtonText: "Ok",
          confirmButtonColor: "#006837",
        }).then(() => {
          navigate("/login");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
          confirmButtonText: "Ok",
          confirmButtonColor: "red",
        });
        console.error("Registration failed:", response.data.msg);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        confirmButtonText: "Ok",
        confirmButtonColor: "red",
      });
      console.error("Error submitting form:", error);
    }
  };

  function onChange(value) {
    console.log("Captcha value:", value);
    setVerifyCaptcha(true);
  }

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div className="account-page register text-center">
          <div className="container" id="reg">
            <div className="account-title">
              <h4 className="heading-light">REGISTRATION</h4>
            </div>
            <div className="account-content">
              <form onSubmit={handleSubmit}>
                <div className="input-box fullname">
                  <input type="text" name="name" id="name" placeholder="Full Name" />
                </div>
                <div className="input-box email">
                  <input type="text" name="email" id="email" placeholder="Email Address" />
                </div>

                <div className="input-box password">
                  <input type="password" name="password" id="password" placeholder="Password" />
                </div>
                <div className="input-box confirm_password">
                  <input
                    type="password"
                    name="confirm_password"
                    id="confirm_password"
                    placeholder="Confirm Password"
                  />
                </div>

                <div className="input-box recaptcha">
                  <ReCAPTCHA
                    sitekey="6LfwAyApAAAAAJAI-7MegdhFhNAu1dvU18E9XHOe"
                    onChange={onChange}
                  />
                </div>
                <div className="buttons-set">
                  <button
                    type="submit"
                    className="bnt bnt-theme text-regular text-uppercase"
                    disabled={!verifyCaptcha}
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
